<div class="container-fluid p-0 sticky-top">
    <div id="loader" *ngIf="enableLoader"></div>
    <div *ngIf="!enableLoader">

<div class="mb-0 py-3 border-bottom " style="background: #F8F9FA;">
    <div class="container">
    <a class="strong  text-primary" (click)="backToDeliveryList()">< {{  'home.vms.back' | cxTranslate }}</a></div><!--{{  'home.vms.back' | cxTranslate }}-->
</div>

<div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
    <div class="container ">
        <div class="row d-flex justify-content-between">
            <div class="col-md-2 col-lg-2 pl-0 mr-auto">
                <h6 class="pt-2 pb-2 col" *ngIf="dvldDetails.batchStatusCode == 'NEW'"><span class="badge badge-primary badge-set">{{dvldDetails.batchStatus}}</span></h6>
                <h6 class="pt-2 pb-2 col" *ngIf="dvldDetails.batchStatusCode == 'INPROGRESS'"><span class="badge badge-blue badge-set">{{dvldDetails.batchStatus}}</span></h6> 
                <h6 class="pt-2 pb-2 col" *ngIf="dvldDetails.batchStatusCode == 'ASSIGNED'"><span class="badge badge-color badge-set">{{dvldDetails.batchStatus }}</span></h6>
                <h6 class="pt-2 pb-2 col" *ngIf="dvldDetails.batchStatusCode == 'COMPLETED'"><span class="badge badge-black badge-set badge-set-black">{{dvldDetails.batchStatus }}</span></h6>
            </div>
            <div class=" d-none d-md-block d-lg-block col-md-2 col-lg-2">
                <p class="small strong text-secondary mb-2">{{  'home.vms.batchComp' | cxTranslate }}</p>
                <div class="btn-group btn-group-sm btn-group-toggle mr-5" data-toggle="buttons" style="width:120px">
                    <label id="yes" class="btn m-0 border1 text-secondary pd-tp-bt " [ngClass]="dvldDetails.isBatchCompleted==true? ' disabled-highlight ':batchCompFlag==true?'active_yes':'deactive'" (click)="checkBatchCompleted('yes')">
                        <input type="radio" formControlName="clearence" name="options" id="{{'optionyes'}}" [disabled]="batchCompFlag==true"
                            class="h6 btn btn-block btn-light m-0 border1 ">{{ 'shipment.yes' | cxTranslate }}</label>
                    <label  id="no" class="btn m-0 border1 pd-tp-bt" [ngClass]="dvldDetails.isBatchCompleted==false && batchCompFlag==false? 'active_no':dvldDetails.isBatchCompleted==false && batchCompFlag==false?'':'disabled'" (click)="checkBatchCompleted('no')">
                        <input type="radio" formControlName="clearence" name="options" id="{{'optionno'}}"  [disabled]="batchCompFlag==true"
                            class="h6 btn btn-block btn-light m-0 border1">{{ 'shipment.no' | cxTranslate }}</label>
                        
                </div>

                <!-- <label id="yes" *ngFor="let btn of clearenceValues;let r=index;" class="btn m-0 border1 " [ngClass]="checkCustomClearenceFlag==true? 'active':''" (click)="checkCustomClearence(btn.id)">
                    <input type="radio"  formControlName="btn.id" name="btn.id" id="{{'option'+btn.id}}" 
                        class="h6 btn btn-block btn-light m-0 border1">{{btn.name}}</label>
        -->       
            </div>  
             <div *ngIf="(dvldDetails.batchStatusCode == 'COMPLETED')" class="justify-content-end">
                        <button *ngIf="isAgentInvoiceActive === 'true'"
                            class="btn btn-sm strong btn-primary border rounded btnheight pl-5 pr-5"
                            (click)="openInvoices(dvldDetails)">{{'shipment.invoice.attachInvoice' |
                            cxTranslate}}</button>
                    </div>
        </div>        
        <div class=" ">
            <h2 class="h4 bold">{{dvldDetails.batchId}}</h2>
            <h2 class="h4 mb-4 text-secondary">{{dvldDetails.vesselName}}</h2>
        </div>
        <div class="row d-flex ml-0 mr-0">
            <div class="col-sm-4 d-none d-md-block d-lg-block col-md-2 col-lg-2 pl-0">
                <p class="small strong text-secondary mb-2">{{  'home.vms.dischargePort' | cxTranslate }}</p>
                <h4 class="h4 bold">{{dvldDetails.portName?dvldDetails.portName:'--'}}</h4>
            </div>
            <div class="col-sm-4 d-none d-md-block d-lg-block col-md-4 col-lg-4 pl-0">
                <p class="small strong text-secondary mb-2">{{  'home.vms.material' | cxTranslate }}</p>
                <h4 class="h4 bold">{{dvldDetails.productName?dvldDetails.productName:'--'}}</h4>
            </div>
            
            <div class="col-sm-4 d-none d-md-block d-lg-block col-md-2 col-lg-2 pl-0">
                <p class="small strong text-secondary mb-2"> {{  'home.vms.Quantity' | cxTranslate }}</p>
                <h4 class="h4 bold">{{dvldDetails.quantity?dvldDetails.quantity:'--' }}</h4>
            </div>
            <div class="col-sm-4 d-none d-md-block d-lg-block col-md-2 col-lg-2 pl-0 ">
                <div class="small strong text-secondary mb-2">{{  'home.vms.Delivered' | cxTranslate }}</div>
                <div class="h4 bold">{{dvldDetails.deliveredInventory?dvldDetails.deliveredInventory:'--' }}</div>
            </div>
            <div class="col-sm-4 d-none d-md-block d-lg-block col-md-2 col-lg-2 pl-0 ">
                <div class="small strong text-secondary mb-2">{{  'home.vms.ramainingInv' | cxTranslate }}</div>
                <div class="h4 bold">{{dvldDetails.remainingInventory?dvldDetails.remainingInventory:'--' }}</div>
            </div>
               
        
        </div>
                <!--mobile view-->
                <div class=" d-lg-none">
                    <div class="row">
                        <div class="col-12">
                            <div class="small strong text-secondary mb-1">{{ 'home.vms.material' | cxTranslate }}</div>
                            <div class="h5 bold mb-2">{{dvldDetails.productName ? dvldDetails.productName : '--'}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="small strong text-secondary mb-1">{{ 'home.vms.dischargePort' | cxTranslate }}</div>
                            <div class="h5 bold mb-2">{{dvldDetails.portName ? dvldDetails.portName : '--'}}</div>
                        </div>
                        <div class="col-6">
                            <div class="small strong text-secondary mb-1">{{ 'home.vms.Quantity' | cxTranslate }}</div>
                            <div class="h5 bold mb-2">{{dvldDetails.quantity ? dvldDetails.quantity : '--'}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="small strong text-secondary mb-1">{{ 'home.vms.Delivered' | cxTranslate }}</div>
                            <div class="h5 bold mb-2">{{dvldDetails.deliveredInventory ? dvldDetails.deliveredInventory : '--'}}</div>
                        </div>
                        <div class="col-6">
                            <div class="small strong text-secondary mb-1">{{ 'home.vms.ramainingInv' | cxTranslate }}</div>
                            <div class="h5 bold mb-2">{{dvldDetails.remainingInventory ? dvldDetails.remainingInventory : '--'}}</div>
                        </div>
                    </div>
                </div>

        <!--end mobile view-->
    </div>
</div>
<!--mobile view-->
<div class="d-flex justify-content-between mt-3 d-lg-none">
    <p class="small strong text-secondary mb-2 ml-3">{{  'home.vms.batchComp' | cxTranslate }}</p>
    <div class="btn-group btn-group-toggle col-7 pl-4" data-toggle="buttons">
        <label id="yes" class="btn m-0 border1 text-secondary button-size " [ngClass]="dvldDetails.isBatchCompleted==true? ' disabled-highlight ':batchCompFlag==true?'active_yes':'deactive'" (click)="checkBatchCompleted('yes')">
            <input type="radio" formControlName="clearence" name="options" id="{{'optionyes'}}" [disabled]="batchCompFlag==true"
                class="h6 btn btn-block btn-light m-0 border1 ">{{ 'shipment.yes' | cxTranslate }}</label>
        <label  id="no" class="btn m-0 border1  button-size " [ngClass]="dvldDetails.isBatchCompleted==false && batchCompFlag==false? 'active_no':dvldDetails.isBatchCompleted==false && batchCompFlag==false?'':'disabled'" (click)="checkBatchCompleted('no')">
            <input type="radio" formControlName="clearence" name="options" id="{{'optionno'}}"  [disabled]="batchCompFlag==true"
                class="h6 btn btn-block btn-light m-0 border1">{{ 'shipment.no' | cxTranslate }}</label>
               
    </div>
    <!--end mobile view-->

    <!-- <label id="yes" *ngFor="let btn of clearenceValues;let r=index;" class="btn m-0 border1 " [ngClass]="checkCustomClearenceFlag==true? 'active':''" (click)="checkCustomClearence(btn.id)">
        <input type="radio"  formControlName="btn.id" name="btn.id" id="{{'option'+btn.id}}" 
            class="h6 btn btn-block btn-light m-0 border1">{{btn.name}}</label>
-->       
</div> 
<div class="container py-2">
     <div class="d-flex justify-content-between">
    <div>
        <h5 class="small bold text-secondary">{{  'batches.attatchments' | cxTranslate }} <span *ngIf="dvldDetails.documents.length>0">({{dvldDetails.documents.length}})</span> <span class="bold" *ngIf="dvldDetails.documents.length==0">(0)</span></h5>
        <span  class="text-secondary " *ngIf="dvldDetails.documents.length==0">{{  'batches.noFilesAttached' | cxTranslate }} </span>
        <span class="mt-2" *ngIf="dvldDetails.documents && dvldDetails.documents.length >= 1" >
            <span *ngFor="let attachment of dvldDetails.documents">
                <i  class="mt-1 mr-1 fas fa-file-alt text-primary"></i>
                    <a target="_blank" class="ml-1 mb-0 semi-bold attachment fw-600 shadow-none" href="{{attachment.downloadURL}}">
                        <small  class="font-weight-bold text-primary">{{attachment.documentName}}</small>
                    </a> &nbsp;
            </span>
        </span>
        <span class="ml-3"><a class="text-blue text-decoration-underline" (click)="goToAttachment()">{{  'batches.addFiles' | cxTranslate }}</a></span>
    </div>                    
</div>
</div>
<div class="container pl-0 py-4">
    <div *ngIf="dvldDetails.nominationItems.length === 0" class="d-flex justify-content-center bold text-secondary mt-5">{{  'home.vms.noNominations' | cxTranslate }}</div>
    <div class="col-md-12 col-lg-12 " *ngFor="let data of dvldDetails.nominationItems">
        <div class="card d-none d-md-block d-lg-block mt-4 mb-4 card-border border-radius-05 mx-2">
            <div class="d-flex justify-content-between mt-2 py-1 px-4">
                <div>
                    <h6 class="pl-1"><span class="badge badge-blue badge-set">{{data.nominationNumber}}</span></h6>
                </div>
                <div class="col-md-4 d-flex justify-content-between">
                <p class="small text-secondary mb-2 px-2">{{  'home.vms.lastDelDate' | cxTranslate }}: {{data.lastDeliveryDate?data.lastDeliveryDate:'DD/MM/YYYY'}}</p>
                <p class="small text-secondary mb-2 px-2">{{  'shipment.noPickUp' | cxTranslate }}: {{data.numberOfPickups}}</p>
                </div>
            </div>
            <div class="hr mt-0 mb-1"></div>
            <div class="row ">
                <div class=" col-md-5 ml-4">
                    <div class="small text-secondary">{{  'home.vms.customer' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.customerName?data.customerName:'--'}}</div>
                </div>
                <div class=" col-md-2 ml-4">
                    <div class="small text-secondary">{{  'shipment.scheduleQty' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.actualQuantity?data.actualQuantity:'--'}}</div>
                </div>
                <div class="col-md-2 ml-4">
                    <div class="small text-secondary">{{  'home.vms.totalDel' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.totalDelivered }}</div>
                </div>
                
                <div class=" col-md-2 ml-4">
                    <div class="small text-secondary">{{  'home.vms.delCompleted' | cxTranslate }}</div>
                    <div class="small text-black strong"><span [ngStyle]="{'background-color':data.isDeliveryCompleted === false?'#01515F':'#28A745'}" class="small badge text-white">{{data.isDeliveryCompletedLocale | uppercase}}</span></div>
                </div>
            </div>
            <div class="hr mt-3 mb-1"></div>
            <div class="mx-4 mt-2 mb-3  d-flex justify-content-end">               
                <button (click)="recordPickUpModal(data)" class="btn btn-primary-record  rounded pl-5 pr-5 bg-transparent">{{  'home.vms.recDel' | cxTranslate }}</button>             
            </div> 
        </div>
        <!--mobile view-->
        <div class="card mt-4 mb-4 card-border d-lg-none border-radius-05 mx-2">
            <div class="ml-3 mt-3">
                <div>
                    <h6 class="pl-1"><span class="badge badge-blue badge-set">{{data.nominationNumber}}</span></h6>
                </div>
                <div class="mt-2 py-1 px-2 d-flex justify-content-between">
                <p class="small text-secondary mb-2 ">{{  'home.vms.lastDelDate' | cxTranslate }}: {{data.lastDeliveryDate?data.lastDeliveryDate:'DD/MM/YYYY'}}</p>
                <p class="small text-secondary mb-2 text-nowrap">{{  'shipment.noPickUp' | cxTranslate }}: {{data.numberOfPickups}}</p>
                </div>
            </div>
            <div class="hr mt-0 mb-4"></div>
            <div class="row ">
                <div class=" col-md-5 ml-4">
                    <div class="small text-secondary">{{  'home.vms.customer' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.customerName?data.customerName:'--'}}</div>
                </div>
                <div class="d-flex mt-3 justify-content-between">
                <div class=" col-md-2 ml-4  text-nowrap">
                    <div class="small text-secondary">{{  'shipment.scheduleQty' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.actualQuantity?data.actualQuantity:'--'}}</div>
                </div>
                <div class="col-md-2 ml-4">
                    <div class="small text-secondary">{{  'home.vms.totalDel' | cxTranslate }}</div>
                    <div class="small text-black strong">{{data.totalDelivered }}</div>
                </div>
                </div>
                
                <div class=" col-md-2 mt-3 ml-4">
                    <div class="small text-secondary">{{  'home.vms.delCompleted' | cxTranslate }}</div>
                    <div class="small text-black strong"><span [ngStyle]="{'background-color':data.isDeliveryCompleted === false?'#01515F':'#28A745'}" class="badge text-white small">{{data.isDeliveryCompletedLocale | uppercase}}</span></div>
                </div>
            </div>
            <div class="hr mt-3 mb-1"></div>
            <div class="mx-4 mt-2 mb-3 ">               
                <button (click)="recordPickUpModal(data)" class="btn w-100 btn-primary-record  rounded  bg-transparent"><span class="text-center">{{  'home.vms.recDel' | cxTranslate }}</span></button>             
            </div> 
        </div>
        <!--end mobile view-->
    </div>
</div>
</div>
</div>
<!-- <div  class="mr-3">
    <button (click)="recordPickUpModal()" class="btn btn btn-light border rounded pl-5 pr-5 bg-transparent strong">Record pick up</button>
</div> -->
